import * as XLSX from 'xlsx';


export const exportPortfolioSummaryToExcel = (sectorData, sectorHealth, stats, t) => {
    
    const wsData = [
        
        [
            t('loans.sector'),
            t('nav.loans'),
            t('reports.exposure'),
            t('reports.percentPortfolio'),
            t('dashboard.compliant'),
            t('dashboard.atRisk'),
            t('dashboard.breach'),
            `${t('reports.compliance')} %`
        ]
    ];

    
    sectorData.forEach(sector => {
        const health = sectorHealth.find(s => s.sector === sector.name) || { compliant: 0, atRisk: 0, breach: 0 };
        const total = health.compliant + health.atRisk + health.breach;
        const complianceRate = total > 0 ? ((health.compliant / total) * 100).toFixed(0) : 0;
        const portfolioShare = stats.totalValue > 0 ? ((sector.value / stats.totalValue) * 100).toFixed(1) : '0.0';

        wsData.push([
            sector.name,
            sector.count,
            sector.value,
            `${portfolioShare}%`,
            health.compliant,
            health.atRisk,
            health.breach,
            `${complianceRate}%`
        ]);
    });

    
    wsData.push([
        'Total',
        stats.totalLoans,
        stats.totalValue,
        stats.totalLoans > 0 ? '100%' : '0%',
        stats.ok,
        stats.warning,
        stats.critical,
        `${stats.complianceRate}%`
    ]);

    
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    
    ws['!cols'] = [
        { wch: 20 }, 
        { wch: 10 }, 
        { wch: 18 }, 
        { wch: 12 }, 
        { wch: 12 }, 
        { wch: 10 }, 
        { wch: 10 }, 
        { wch: 12 }, 
    ];

    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, t('reports.portfolioSummary'));

    
    const date = new Date().toISOString().split('T')[0];
    const filename = `portfolio_summary_${date}.xlsx`;

    
    XLSX.writeFile(wb, filename);
};


export const exportCompleteReportToExcel = (loans, sectorData, sectorHealth, countryData, stats, t) => {
    const wb = XLSX.utils.book_new();

    
    const summaryData = [
        [t('loans.sector'), t('nav.loans'), t('reports.exposure'), t('reports.percentPortfolio'), t('dashboard.compliant'), t('dashboard.atRisk'), t('dashboard.breach'), `${t('reports.compliance')} %`]
    ];

    sectorData.forEach(sector => {
        const health = sectorHealth.find(s => s.sector === sector.name) || { compliant: 0, atRisk: 0, breach: 0 };
        const total = health.compliant + health.atRisk + health.breach;
        const complianceRate = total > 0 ? ((health.compliant / total) * 100).toFixed(0) : 0;
        const portfolioShare = stats.totalValue > 0 ? ((sector.value / stats.totalValue) * 100).toFixed(1) : '0.0';

        summaryData.push([
            sector.name,
            sector.count,
            sector.value,
            `${portfolioShare}%`,
            health.compliant,
            health.atRisk,
            health.breach,
            `${complianceRate}%`
        ]);
    });

    summaryData.push(['Total', stats.totalLoans, stats.totalValue, '100%', stats.ok, stats.warning, stats.critical, `${stats.complianceRate}%`]);

    const summaryWs = XLSX.utils.aoa_to_sheet(summaryData);
    summaryWs['!cols'] = [{ wch: 20 }, { wch: 10 }, { wch: 18 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, summaryWs, t('reports.portfolioSummary'));

    
    const loansData = [
        [t('loans.borrower'), t('loans.amount'), t('loans.sector'), t('loans.country'), t('common.status')]
    ];

    loans.forEach(loan => {
        loansData.push([
            loan.borrower,
            loan.amount,
            loan.sector,
            loan.country,
            loan.status === 'ok' ? t('dashboard.compliant') : loan.status === 'warning' ? t('dashboard.atRisk') : t('dashboard.breach')
        ]);
    });

    const loansWs = XLSX.utils.aoa_to_sheet(loansData);
    loansWs['!cols'] = [{ wch: 25 }, { wch: 18 }, { wch: 15 }, { wch: 15 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, loansWs, t('nav.loans'));

    
    const geoData = [
        [t('loans.country'), t('nav.loans'), t('reports.exposure')]
    ];

    countryData.forEach(country => {
        geoData.push([
            country.name,
            country.count,
            country.value
        ]);
    });

    const geoWs = XLSX.utils.aoa_to_sheet(geoData);
    geoWs['!cols'] = [{ wch: 20 }, { wch: 10 }, { wch: 18 }];
    XLSX.utils.book_append_sheet(wb, geoWs, t('reports.geographicExposure'));

    
    const date = new Date().toISOString().split('T')[0];
    const filename = `portfolio_report_${date}.xlsx`;

    
    XLSX.writeFile(wb, filename);
};